import { Amplify } from 'aws-amplify'
import {
  cognitoClientId,
  cognitoPoolId,
  cognitoRegion,
  cognitoDomain,
  cognitoIdentityPoolId,
  cognitoRedirectUri,
} from '../utils/env'

const normalizedCognitoDomain = (cognitoDomain ?? '')
  .replace(/^https?:\/\//, '')
  .replace(/\/+$/, '')

Amplify.configure({
  identityPoolId: cognitoIdentityPoolId,
  userPoolId: cognitoPoolId,
  userPoolWebClientId: cognitoClientId,
  region: cognitoRegion,
  oauth: {
    domain: normalizedCognitoDomain,
    redirectSignIn: cognitoRedirectUri ?? '',
    redirectSignOut: cognitoRedirectUri ?? '',
    scope: [
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin',
    ],
    responseType: 'code'
  },
})
